import { defineComponent as _defineComponent } from 'vue'
import {Contact, ContactGroup} from '@/models/dto/ContactGroup'
import ContactListItem from '@/components/Contact/ContactListItem.vue'
import {computed} from "vue";
import { getRoleLabelByKey } from '@/utils/urmUtils';
import { URMRoleKey } from '@/models/dto/userRoleManagement';
import sortBy from 'lodash/sortBy';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactList',
  props: {
    contactGroups: null,
    hideEdit: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    reservationId: null,
    hideDelete: { type: Boolean, default: false },
    alignLeft: { type: Boolean, default: true }
  },
  emits: ['refresh', 'click:delete-contact', 'update:contact', 'click:edit-contact', 'update:input', 'click:delete-contact'],
  setup(__props: any, { emit }) {

const props = __props as { contactGroups: ContactGroup[], hideEdit: boolean, isLoading: boolean, reservationId?: number, hideDelete: boolean, alignLeft: boolean };





const sortedContactGroups = computed(() => {
     return props.contactGroups.map(group => {
       const sortedContacts = sortBy(group.contacts, contact => (contact.name || contact.email || '').toLowerCase());
       return {
         ...group,
         contacts: sortedContacts,
       };
     });
   });

const groupKeyToLabel = (groupKey: string): string => {
  return getRoleLabelByKey(groupKey)
}

const onContactEditClick = (contact: Contact) => {
    emit('click:edit-contact', contact)
}

const onDeleteContactClick = (contact: Contact) => {
  emit('click:delete-contact', contact)
}

return { __sfc: true,emit, props, sortedContactGroups, groupKeyToLabel, onContactEditClick, onDeleteContactClick, ContactListItem, URMRoleKey }
}

})